import React from 'react';
import { DocumentSection } from '../ast/document.types';
import { BlockRenderer } from './BlockRenderer';
import { SelectableBlockWrapper } from '../manual-edit/SelectableBlockWrapper';

export interface ManualEditRenderOptions {
  isManualEditMode: boolean;
  selectedBlockId: string | null;
  selectedSectionId: string | null;
  onSelectBlock: (blockId: string, sectionId: string) => void;
  onUpdateText?: (sectionId: string, blockId: string, text: string) => void;
  onNudge?: (sectionId: string, blockId: string, dx: number, dy: number) => void;
  onDelete?: (sectionId: string, blockId: string) => void;
  onDuplicate?: (sectionId: string, blockId: string) => void;
}

interface SectionRendererProps {
  section: DocumentSection;
  sectionNumber?: number;
  manualEditOptions?: ManualEditRenderOptions;
}

export const SectionRenderer: React.FC<SectionRendererProps> = ({ section, sectionNumber, manualEditOptions }) => {
  if (!section.enabled) return null;

  const showHeader = section.type !== 'cover';
  const headingText = typeof sectionNumber === 'number' && section.settings?.numbered !== false
    ? `${sectionNumber}. ${section.title}`
    : section.title;

  return (
    <div
      className="doc-section-container"
      data-section-id={section.id}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        marginBottom: '20px',
      }}
    >
      {showHeader && (
        <h2
          style={{
            fontSize: '14px',
            fontWeight: 700,
            color: '#111827',
            borderBottom: '1px solid #e5e7eb',
            paddingBottom: '4px',
            textTransform: 'uppercase',
            letterSpacing: '0.03em',
            margin: '8px 0 4px',
          }}
        >
          {headingText}
        </h2>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {section.blocks.map((block) => (
          <SelectableBlockWrapper
            key={block.id}
            block={block}
            sectionId={section.id}
            isSelected={manualEditOptions?.selectedBlockId === block.id}
            isManualEditMode={!!manualEditOptions?.isManualEditMode}
            onSelect={manualEditOptions?.onSelectBlock || (() => {})}
            onUpdateText={manualEditOptions?.onUpdateText}
            onNudge={manualEditOptions?.onNudge}
            onDelete={manualEditOptions?.onDelete}
            onDuplicate={manualEditOptions?.onDuplicate}
          >
            <BlockRenderer block={block} />
          </SelectableBlockWrapper>
        ))}
      </div>
    </div>
  );
};
